module.exports = __webpack_public_path__ + "static/van-d093dc407136363b2c78649b60c6cf64.webp";